import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import CustomToast from '../../../../components/Toast';
import { useState } from 'react';
import { DataProvider } from '../../../assignments/DataContext';
import AssignmentCreateContent from '../../../assignments/components/AssignmentCreateContent';
import AddQuestionsToExisting from '../castleQuestionsSearch/components/questionResults/components/addQuestionsToExisting';
import { useAssignmentContext } from '../../../assignments/context';
import { useNavigate, useParams } from 'react-router';
import AddQuestionsToAssignment from '../addQuestionsToAssignment';
import AssignmentStatus from '../../../../enums/assignmentStatus';
import { useAddRandomMathSkillQuestionsMutation } from '../../../../features/authentication/assignmentApislice';
import CreateQuestionSetModel from '../../../myContent/pages/questionSets/components/CreateQuestionSetModel';
import { useAddRandomMathSkillToQSetMutation } from '../../../../features/authentication/qSetApiSlice';

const AddRandomMathSkillQuestions = ({ selectedCourseId, selectedLevelId, selectedTopicId, selectedSkillId }) => {
  const { assignmentId, from, qSetId } = useParams();
  const [openOptionTileModal, setOpenOptionTileModal] = useState(false);
  const [randomCount, setRandomCount] = useState(20);
  const [dateBasedKey] = useState(new Date().getTime().toString());
  const [openQsetCreateModal, setOpenQsetCreateModal] = useState(false);

  const [addRandomMathSkillQuestions] = useAddRandomMathSkillQuestionsMutation();
  const [addRandomMathSkillQuestionsToQSet]= useAddRandomMathSkillToQSetMutation();
  const { mcChoices, assignmentAssignedViaDetails, setAssignmentAssignedViaDetails } = useAssignmentContext();
  const navigate = useNavigate();

  const saveComponentAddToExisting = <AddQuestionsToExisting key={'update' + dateBasedKey}
    handleSave={(id) => addQuestionsToExistingAssignment(id)}
    handleCancel={() => setOpenOptionTileModal(false)} />;

  const saveComponentCreate =
    <DataProvider>
      <AssignmentCreateContent
        key={'create' + dateBasedKey}
        showBrowseContent={false}
        showTitle={false} showCancelButton={true}
        handleCancel={() => setOpenOptionTileModal(false)}
        onCreateSuccess={(id, assignedViaDetails) => addQuestionsToExistingAssignment(id, assignedViaDetails)}
      />
    </DataProvider>;

  const handleAddRandomQuestions = () => {
    if (randomCount.length === 0 || randomCount === 0|| randomCount > 100) {
      CustomToast('Maximum number of questions to add (1 - 100)', 'error');
      return;
    }

    if(from == 'qSet') {
      if (qSetId) {
        addToQSet(qSetId);
      } else {
        setOpenQsetCreateModal(true);
      }
    }
    else {
      if (assignmentId) {
        addQuestionsToExistingAssignment(assignmentId);
      } else {
        setOpenOptionTileModal(true);
      }
    }

  };

  const addQuestionsToExistingAssignment = async (existingAssignmentId, assignedViaDetails) => {
    await addToAssignment(existingAssignmentId);
    if (assignmentAssignedViaDetails?.id == null && assignedViaDetails?.id != null)
      setAssignmentAssignedViaDetails({ assignedViaDetails });

    navigate('/assignments/' + existingAssignmentId + '/edit_assignment', { state: { assignedStatus: AssignmentStatus.NotAssigned, mcChoices: mcChoices } });
  };

  const addToAssignment = async (existingAssignmentId) => {
    const options = {
      assignmentId: existingAssignmentId,
      params: {
        courseId: selectedCourseId,
        levelId: selectedLevelId,
        topicId: selectedTopicId,
        skillId: selectedSkillId,
        questionCount: randomCount,
      }
    };
    const response = await addRandomMathSkillQuestions(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast(`${randomCount} questions were added to the assignment.`, 'success');
      setOpenOptionTileModal(false);
    }
  };

  const addToQSet = async (qSetId) => {
    const options = {
      id: qSetId,
      params: {
        courseId: selectedCourseId,
        levelId: selectedLevelId,
        topicId: selectedTopicId,
        skillId: selectedSkillId,
        questionCount: randomCount
      }
    };
    const response = await addRandomMathSkillQuestionsToQSet(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast(`${randomCount} questions were added.`, 'success');
      setOpenOptionTileModal(false);
      navigate('/mycontent/questionsets/'+qSetId+'/questions');
    }
  };

  return (
    <>
      <div className="w-100">
        <div className="d-flex align-items-center gap-3 justify-content-end">
          <div><label>Maximum number of questions to add (1 - 100)</label></div>
          <div className="w-15">
            <input
              type="text"
              className="form-control"
              placeholder=" "
              name="questionRange"
              id="questionRange"
              value={randomCount}
              onChange={(e) => (e.target.value.length > 0 && /^[0-9]*\.?[0-9]*$/.test(e.target.value)) ? setRandomCount(parseInt(e.target.value)) : setRandomCount('')}
            />
          </div>
          <div><Button className='btn btn-castleRed py-0' onClick={() => handleAddRandomQuestions()}>Add Randomly Selected Questions</Button></div>
        </div>
      </div>
      {openOptionTileModal &&
        <>
          <AddQuestionsToAssignment
            key={'component' + dateBasedKey}
            openOptionTileModal={openOptionTileModal}
            setOpenOptionTileModal={setOpenOptionTileModal}
            saveComponentCreate={saveComponentCreate}
            saveComponentAddToExisting={saveComponentAddToExisting}
          />
        </>
      }

      {openQsetCreateModal &&
          <CreateQuestionSetModel
            key={'createQSet' + dateBasedKey}
            isOpen={openQsetCreateModal}
            onClose={() => setOpenQsetCreateModal(false)}
            showQuestionOptions={false}
            onCreateSuccess={(id) => addToQSet(id)}
          />
      }
    </>
  );
};

AddRandomMathSkillQuestions.propTypes = {
  selectedCourseId: PropTypes.number,
  selectedLevelId: PropTypes.number,
  selectedTopicId: PropTypes.number,
  selectedSkillId: PropTypes.number,
};

export default AddRandomMathSkillQuestions;
